import React, { createContext, useContext } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import t, { LANGS } from "./translations";

const LanguageContext = createContext(null);
const SUPPORTED = LANGS.map((l) => l.code);

export const LanguageProvider = ({ children }) => {
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const lang = SUPPORTED.includes(params.lang) ? params.lang : "fr";

  const tr = t[lang];

  const setLang = (newLang) => {
    const parts = location.pathname.split("/");
    parts[1] = newLang;
    navigate(parts.join("/") + location.search);
  };

  // build a localized path e.g. lp("/faq") -> "/fr/faq"
  const lp = (path) => `/${lang}${path.startsWith("/") ? path : "/" + path}`;

  return (
    <LanguageContext.Provider value={{ lang, tr, setLang, lp, langs: LANGS }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};

export const localized = (field, lang) => {
  if (field == null) return "";
  if (typeof field === "string") return field;
  return field[lang] || field.en || field.fr || Object.values(field)[0] || "";
};
